import React, { useEffect, useMemo, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import {
  FaChevronLeft,
  FaChevronRight,
  FaEye,
  FaPen,
  FaPlus,
  FaTrash,
  FaX,
} from "react-icons/fa6"
import { Link, useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import Breadcrumb from "../../components/Common/Breadcrumb"
import Configs from "../../config"
import ActivityModal from "pages/Plans/addActivity"
import { Calendar, momentLocalizer } from "react-big-calendar"
import moment from "moment"
import { fetchData } from "utils/Common_api_functions"
import Loader from "components/Loader/loader"

const ActivityReport = () => {
  const navigate = useNavigate()

  const [planModal, setPlanModal] = useState(false)
  const localizer = momentLocalizer(moment)

  const [events, setEvents] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedDate, setSelectedDate] = useState(null)
  const [editingEvent, setEditingEvent] = useState(null) // NEW: event being edited

  const [loading, setLoading] = useState(false)

  const handleSaveActivity = activity => {
    if (editingEvent) {
      // Update existing event
      setEvents(prev =>
        prev.map(evt => (evt === editingEvent ? activity : evt))
      )
    } else {
      // Add new event
      setEvents(prev => [...prev, activity])
    }
    setIsModalOpen(false)
    setEditingEvent(null)
    setSelectedDate(null)
  }
  const rangeEvents = useMemo(() => events, [events])

  const [plans, setPlans] = useState([])

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(plans?.length / items_perpage)

  const final_data = plans.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  useEffect(() => {
    getPlanData()
  }, [])

  async function getPlanData() {
    const APIdata = await fetchData(setLoading, "reports/activities")
    if (APIdata?.success) {
      setPlans(APIdata?.data)
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="Reports" breadcrumbItem="Activities" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="text-black fw-bold mb-0">
                    User Activity Report
                  </h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input placeholder="Search Activity" />
                    </div>
                  </div>
                </div>

                <Table responsive bordered className="rounded-3">
                  <thead className="table-primary text-dark">
                    <tr>
                      <th>ID</th>
                      <th>User Name</th>
                      <th>Plan Name</th>
                      <th>Plan Start</th>
                      <th>Plan End</th>
                      <th>Total Days</th>
                      <th>Completed Days</th>
                      <th>Total Activities</th>
                      <th>Completed Activities</th>
                    </tr>
                  </thead>
                  <tbody>
                    {plans.map((plan, index) => (
                      <tr key={plan.id}>
                        <td>{index * items_perpage + 1}</td>
                        <td>{plan.userName}</td>
                        <td>{plan?.planName}</td>
                        <td>{plan.planStartDate ? moment(plan.planStartDate).format("DD-MM-YYYY") : "--"}</td>
                        <td>{plan.planEndDate ? moment(plan.planEndDate).format("DD-MM-YYYY") : "--"}</td>
                        <td>{plan?.totalDays}</td>
                        <td>{plan.completedDays}</td>
                        <td>{plan?.totalActivities}</td>
                        <td>{plan.completedActivities}</td>
                      </tr>
                    ))}
                    {plans.length === 0 && (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No Data available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="d-flex align-items-center justify-content-between my-2 px-2">
                  <p className="mb-0 fs-6">
                    Showing {final_data?.length} out of {plans?.length} Clubs.
                  </p>
                  <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                    <div
                      className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-6`}
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {(() => {
                      const maxVisiblePages = 5
                      const startPage = Math.max(
                        1,
                        page - Math.floor(maxVisiblePages / 2)
                      )
                      const endPage = Math.min(
                        total_pages,
                        startPage + maxVisiblePages - 1
                      )
                      const visiblePages = []

                      for (let i = startPage; i <= endPage; i++) {
                        visiblePages.push(i)
                      }

                      return visiblePages.map(pagecount => (
                        <div
                          key={pagecount}
                          className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-6 ${
                            page === pagecount ? "activepage" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => changePage(pagecount)}
                        >
                          {pagecount < 10 ? "0" + pagecount : pagecount}
                        </div>
                      ))
                    })()}
                    <div
                      className={`bd-number-pagination cursor-pointer rounded-2 ms-0 fs-6`}
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={planModal}
          toggle={() => setPlanModal(!planModal)}
          centered
          size="xl"
        >
          <div className="d-flex align-items-center justify-content-between w-100 py-2 px-3 border-bottom border-dark">
            <h4 className="modal-title mb-0">User Activities</h4>
            <button
              className="btn btn-danger"
              onClick={() => setPlanModal(false)}
            >
              <FaX size={16} />
            </button>
          </div>

          <ModalBody className="p-2 mt-2">
            <Calendar
              localizer={localizer}
              events={rangeEvents}
              startAccessor="start"
              endAccessor="end"
              style={{ height: 500 }}
              views={["month", "week", "day"]}
              defaultView="month"
              selectable
              onSelectEvent={event => {
                setSelectedDate(event.start)
                setEditingEvent(event) // Pass the event to edit
                setIsModalOpen(true)
              }}
            />

            <ActivityModal
              isOpen={isModalOpen}
              toggle={() => {
                setIsModalOpen(false)
                setEditingEvent(null)
                setSelectedDate(null)
              }}
              onSave={handleSaveActivity}
              date={selectedDate}
              event={editingEvent}
            />
          </ModalBody>
        </Modal>
      </Container>
    </div>
  )
}

export default ActivityReport
